import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import classNames from 'volta/helpers/class-names';
import stopPropagation from 'volta/helpers/stop-propagation';
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { fn } from '@ember/helper';
import not from 'ember-truth-helpers/helpers/not';
import BvSpinner from 'volta/components/bv-spinner';
import BvTooltip from 'volta/components/bv-tooltip';
import type { TSize } from 'volta/utils/style-utils';
import type { ContentValue } from '@glint/template';
export type TToggleSize = Extract<TSize, 'sm' | 'md'>;
const SIZES: Extract<TSize, 'sm' | 'md'>[] = [
    'sm',
    'md'
];
interface BvToggleSignature {
    Args: {
        size?: TToggleSize;
        toggled: boolean;
        loading?: boolean;
        disabled?: boolean;
        tooltip?: string;
        readOnly?: boolean;
        prefix?: ContentValue;
        postfix?: ContentValue;
        onToggle?: (toggled: boolean) => void;
    };
    Element: HTMLSpanElement;
}
export default class BvToggleComponent extends Component<BvToggleSignature> {
    // Services
    // ~~~~~
    // Properties
    // ~~~~~
    forId = `${guidFor(this)}-bv-toggle`;
    // Computed Properties
    // ~~~~~
    get sizeClass() {
        const { size = 'md' } = this.args;
        return (size && SIZES.includes(`${size}`.toLowerCase() as TToggleSize) && `bv-toggle--${`${size}`.toLowerCase()}`);
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{! template-lint-disable no-invalid-interactive }}
    <span
      class={{classNames
        'bv-toggle'
        (if @toggled 'bv-toggle--checked')
        (if @readOnly 'bv-toggle--read-only')
        (if @disabled 'bv-toggle--disabled')
        (if @loading 'bv-toggle--loading')
        this.sizeClass
      }}
      ...attributes
      {{on 'click' (stopPropagation)}}
    >
      {{#if @prefix}}
        <span class='bv-toggle__text bv-toggle__text--prefix'>
          {{@prefix}}
        </span>
      {{/if}}
      <input
        type='checkbox'
        class='bv-toggle__checkbox'
        id={{this.forId}}
        checked={{@toggled}}
        disabled={{@disabled}}
        {{on 'change' (fn (optional @onToggle) (not @toggled))}}
      />
      <label class='bv-toggle__btn' for={{this.forId}}>
        {{#if @loading}}
          <BvSpinner class='bv-toggle__loading' @size={{@size}} />
        {{/if}}
      </label>
      {{#if @postfix}}
        <span class='bv-toggle__text bv-toggle__text--postfix'>
          {{@postfix}}
        </span>
      {{/if}}
      {{#if @tooltip}}
        <BvTooltip @text={{@tooltip}} />
      {{/if}}
    </span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvToggle: typeof BvToggleComponent;
        'bv-toggle': typeof BvToggleComponent;
    }
}
